<template>
  <div class="no-select">
    <div id="assessment-body">
      <AssessmentStart v-if="preassessmentScreen" @assessment-started="handleAssessmentStart" />
      <Question v-if="assessmentStart" @assessment-finish="handleAssessmentFinish" />
      <AssessmentFinish v-if="assessmentFinish" />
    </div>
  </div>
</template>
  
<script>
 document.addEventListener('contextmenu',
                event => event.preventDefault());

import AssessmentStart from '@/components/CandidateAssessment/AssessmentUI/AssessmentStart.vue'
import AssessmentFinish from '@/components/CandidateAssessment/AssessmentUI/AssessmentFinish.vue'
import Question from '@/components/CandidateAssessment/AssessmentUI/Question.vue'
export default {
  name: 'AssessmentUI',
  components: { 
    AssessmentStart,
    AssessmentFinish,
    Question
   },
  emits: [],
  data() {
    return {
      preassessmentScreen: true,
      assessmentStart: false,
      assessmentFinish: false
    }
  },
  methods: {
    handleAssessmentStart() {
      this.preassessmentScreen = false;
      this.assessmentStart = true;
    },
    handleAssessmentFinish() {
      this.preassessmentScreen = false;
      this.assessmentStart = false;
      this.assessmentFinish = true;
    }
  }
}
</script>

<style scoped>
#assessment-body {
  border-style: solid;
  border-color: rgb(158, 158, 158);
  border-width: 1px;
  border-radius: 10px;
  background-color: #181a1b;
  box-shadow: inset;
  text-align: left;
  padding: 20px;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
}

.no-select {
  user-select: none; /* Standard syntax */
  -webkit-touch-callout: none; /* iOS Safari */
  margin: 0px;
  padding: 0px;
}

</style>